import * as api from '../../api';
import { handleError, receiveSchool, receiveSchools } from '../actionHelpers';

export const fetchSeatLimitsForSchool = (schoolId, userType) => (
  dispatch,
  getState
) => {
  dispatch({
    type: 'FETCH_SEAT_LIMITS_REQUEST',
    schoolId,
    userType,
  });
  const { token } = getState().users.auth;
  return api.getSeatLimitsForSchool(token, schoolId, userType).then(
    (response) => {
      if (response.errorMsg) {
        handleError(dispatch, response, 'FETCH_SEAT_LIMITS_FAILURE');
      } else {
        dispatch({
          type: 'FETCH_SEAT_LIMITS_SUCCESS',
          response,
          schoolId,
          userType,
        });
      }
    },
    (error) => handleError(dispatch, error, 'FETCH_SEAT_LIMITS_FAILURE')
  );
};

export const fetchSchoolDisabledModules = (schoolId) => (
  dispatch,
  getState
) => {
  dispatch({
    type: 'FETCH_DISABLED_MODULES_REQUEST',
    schoolId,
  });

  const {
    auth: { token },
    activeUser,
  } = getState().users;

  console.log('fetching disabled models for school');

  return api.getSchoolDisabledModules(token, schoolId).then(
    (response) => {
      if (response.errorMsg) {
        handleError(dispatch, response, 'FETCH_DISABLED_MODULES_FAILURE');
      } else {
        console.log('fetching disabled models for user classes');
        api
          .getUserClassDisabledModules(token, activeUser.user.id)
          .then((classDisabledModulesResponse) => {
            console.log('school Disabled modules', response);
            console.log('class Disabled modules', classDisabledModulesResponse);
            const classDisabledModules = classDisabledModulesResponse.results;
            const counts = {};
            const mergedClassDisabledModules = [];

            for (let i = 0; i < classDisabledModules.length; i++) {
              const modelName = classDisabledModules[i];
              if (counts[modelName]) {
                counts[modelName]++;
              } else {
                counts[modelName] = 1;
              }
            }

            const max = Math.max(...Object.values(counts));
            Object.keys(counts).forEach((model) => {
              if (counts[model] === max) {
                mergedClassDisabledModules.push(model);
              }
            });
            const combinedResult = {
              classDisabledModules: mergedClassDisabledModules,
              disabledModules: response.results,
            };
            dispatch({
              type: 'FETCH_DISABLED_MODULES_SUCCESS',
              response,
              schoolId,
              combinedResult,
            });
          });
      }
    },
    (error) => handleError(dispatch, error, 'FETCH_DISABLED_MODULES_FAILURE')
  );
};

export const postSchoolDisabledModules = (schoolId, disabledModules) => (
  dispatch,
  getState
) => {
  dispatch({
    type: 'POST_DISABLED_MODULES_REQUEST',
    schoolId,
  });
  const { token } = getState().users.auth;
  return api
    .postSchoolDisabledModules(token, { schoolId, disabledModules })
    .then(
      (response) => {
        if (response.errorMsg) {
          handleError(dispatch, response, 'POST_DISABLED_MODULES_FAILURE');
        } else {
          dispatch(fetchSchoolDisabledModules(schoolId));
          dispatch({
            type: 'POST_DISABLED_MODULES_SUCCESS',
            response,
            schoolId,
          });
        }
      },
      (error) => handleError(dispatch, error, 'POST_DISABLED_MODULES_FAILURE')
    );
};

export const fetchSchool = (schoolId) => (dispatch, getState) => {
  dispatch({
    type: 'FETCH_SCHOOL_REQUEST',
    schoolId,
  });
  const { token } = getState().users.auth;
  return api.getSchool(schoolId, token).then(
    (response) => {
      if (response.errorMsg) {
        handleError(dispatch, response, 'FETCH_SCHOOL_FAILURE');
      } else {
        console.log('getState()');
        console.log(getState());
        dispatch(receiveSchool(response, 'FETCH_SCHOOL_SUCCESS', { schoolId }));
        dispatch(fetchSchoolDisabledModules(schoolId));
      }
    },
    (error) => handleError(dispatch, error, 'FETCH_SCHOOL_FAILURE')
  );
};

export const fetchAllSchools = () => (dispatch, getState) => {
  dispatch({
    type: 'FETCH_ALL_SCHOOLS_REQUEST',
  });
  const { token } = getState().users.auth;
  return api.getSchools(token).then(
    (response) => {
      if (response.errorMsg) {
        handleError(dispatch, response, 'FETCH_ALL_SCHOOLS_FAILURE');
      } else {
        dispatch(receiveSchools(response, 'FETCH_ALL_SCHOOLS_SUCCESS'));
      }
    },
    (error) => handleError(dispatch, error, 'FETCH_ALL_SCHOOLS_FAILURE')
  );
};

export const fetchSchoolLicenses = (schoolId) => (dispatch, getState) => {
  dispatch({
    type: 'FETCH_SCHOOL_LICENSES_REQUEST',
    schoolId,
  });
  const { token } = getState().users.auth;
  return api.getSchoolLicenses(schoolId, token).then(
    (response) => {
      if (response.errorMsg) {
        handleError(dispatch, response, 'FETCH_SCHOOL_LICENSES_FAILURE');
      } else {
        dispatch({
          type: 'FETCH_SCHOOL_LICENSES_SUCCESS',
          response,
          schoolId,
        });
      }
    },
    (error) => handleError(dispatch, error, 'FETCH_SCHOOL_LICENSES_FAILURE')
  );
};
